import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Typography, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(4),
        minHeight: 200
    },
    spinner: {
        marginBottom: theme.spacing(2)
    },
    text: {
        color: theme.palette.text.secondary,
        textAlign: 'center',
        marginTop: theme.spacing(1)
    }
}));

export default function LoadingOverlay({ text = 'Cargando...' }) {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <CircularProgress className={classes.spinner} size={48} />
            {text && (
                <Typography variant="body1" className={classes.text}>
                    {text}
                </Typography>
            )}
        </Box>
    );
}
